export default __webpack_public_path__ + "static/media/slider3en.2dbb942c.jpg";